import { fetchWithAuth } from "@/core/data/fetch-with-auth"
import { parseResponse, parseSuccessResponse } from "@/core/data/parse-response"
import type { DocTypeRepository } from "../../domain/repositories/doc-type-repository"
import type { DocTypeModel } from "../models/doc-type-model"
import { toDocType, toDocTypeList, toDocTypeCreateBody, toDocTypeUpdateBody } from "../mappers/doc-type-mapper"

const BASE = "/api/v1/doc-types"

export const httpDocTypeRepository: DocTypeRepository = {
  async list() {
    const res = await fetchWithAuth(BASE, { method: "GET" })
    return toDocTypeList(await parseResponse<DocTypeModel[]>(res))
  },
  async getById(id) {
    const res = await fetchWithAuth(`${BASE}/${id}`, { method: "GET" })
    return toDocType(await parseResponse<DocTypeModel>(res))
  },
  async create(input) {
    const res = await fetchWithAuth(BASE, { method: "POST", body: JSON.stringify(toDocTypeCreateBody(input)) })
    return toDocType(await parseResponse<DocTypeModel>(res))
  },
  async update(id, input) {
    const res = await fetchWithAuth(`${BASE}/${id}`, { method: "PATCH", body: JSON.stringify(toDocTypeUpdateBody(input)) })
    return toDocType(await parseResponse<DocTypeModel>(res))
  },
  async delete(id) {
    const res = await fetchWithAuth(`${BASE}/${id}`, { method: "DELETE" })
    await parseSuccessResponse(res)
  },
}
